(function(){
 function init(scope){
  (scope||document).querySelectorAll('[data-pe-lifestyle]').forEach(function(root){
   if(root.dataset.peLifestyleReady==='1')return;root.dataset.peLifestyleReady='1';
   var tabs=Array.from(root.querySelectorAll('[data-pe-lifestyle-tab]'));
   var panels=Array.from(root.querySelectorAll('[data-pe-lifestyle-panel]'));
   function refresh(panel){
    if(panel.hidden)return;
    var rail=panel.querySelector('[data-pe-track]'),prev=panel.querySelector('[data-pe-prev]'),next=panel.querySelector('[data-pe-next]');
    if(!rail||!prev||!next)return;
    prev.disabled=rail.scrollLeft<=2;
    next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-3;
   }
   function activate(button,focus){
    var id=button.getAttribute('data-pe-lifestyle-tab');
    tabs.forEach(function(t){var yes=t===button;t.setAttribute('aria-selected',yes?'true':'false');t.tabIndex=yes?0:-1});
    panels.forEach(function(p){p.hidden=p.getAttribute('data-pe-lifestyle-panel')!==id;if(!p.hidden){p.querySelector('[data-pe-track]').scrollLeft=0;refresh(p)}});
    if(focus)button.focus();
   }
   tabs.forEach(function(t,i){t.addEventListener('click',function(){activate(t,false)});
    t.addEventListener('keydown',function(e){var n=-1;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;if(n>=0){e.preventDefault();activate(tabs[n],true)}})
   });
   panels.forEach(function(p){
    var rail=p.querySelector('[data-pe-track]'),prev=p.querySelector('[data-pe-prev]'),next=p.querySelector('[data-pe-next]');
    if(!rail||!prev||!next)return;
    function move(dir){
     var card=rail.querySelector('.pe-lifestyle__item'),gap=parseFloat(getComputedStyle(rail).columnGap)||0;
     var step=card?card.getBoundingClientRect().width+gap:rail.clientWidth*.75;
     var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
     rail.scrollBy({left:dir*step,behavior:reduce?'auto':'smooth'});
    }
    prev.addEventListener('click',function(){move(-1)});
    next.addEventListener('click',function(){move(1)});
    rail.addEventListener('scroll',function(){refresh(p)},{passive:true});
    refresh(p);
   });
   window.addEventListener('resize',function(){panels.forEach(refresh)},{passive:true});
  })
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)},{once:true});else init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target)})
})();